import Dexie from 'dexie';

import { SyncTreeNode } from '@/workerProcessRenderer/scripts/CoSyncEngine/Tree/typings';
import { IgnoredExitRecord } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/IgnoredExit';

export type SyncTreeDAONode = SyncTreeNode & { id?: number };

const coSyncTreeDB = new Map<number, Dexie>();

export function getCoSyncTreeDB(localSyncId: number) {
  let dexie!: Dexie;

  if (coSyncTreeDB.has(localSyncId)) {
    dexie = coSyncTreeDB.get(localSyncId)!;
  } else {
    dexie = new Dexie(`CoSyncTreeDB_${localSyncId}`);
    dexie.version(1).stores({
      syncTree: 'path',
    });
    dexie.version(2).stores({
      syncTree: 'path',
      ignoredExit: 'id,side,sourcePath,ignoredPath,localInode,remoteInode',
    });
  }

  coSyncTreeDB.set(localSyncId, dexie);

  const deleteDB = async () => {
    await dexie.delete();
  };

  return {
    dexie,
    deleteDB,
    syncTree: dexie.table<SyncTreeDAONode, number>('syncTree'),
    ignoredExit: dexie.table<IgnoredExitRecord, string>('ignoredExit'),
  };
}

export type CoSyncTreeDB = ReturnType<typeof getCoSyncTreeDB>;
